import { Fragment } from 'react';
export var isReactFragment = function (node) {
    if (!node)
        return false;
    if (node.type) {
        return node.type === Fragment;
    }
    return node === Fragment;
};
